import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { stripeDashboardURL } from "@/lib/payments";

/** "Open in Stripe": billing's dashboard_url (test or live dashboard), in a new tab. Renders nothing without a Stripe dashboard URL. */
export function StripeLink({
  url,
  label = "Open in Stripe",
  what,
  className,
  showMode = true,
}: {
  url: string | null | undefined;
  label?: string;
  what?: string;
  className?: string;
  /** Adds " (test)" for test-mode links; off where the page already says which mode Stripe is in. */
  showMode?: boolean;
}) {
  const href = stripeDashboardURL(url);
  if (!href) return null;
  const test = href.includes("/test/");
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("inline-flex items-center gap-0.5 whitespace-nowrap text-xs font-medium text-[var(--color-primary)] hover:underline", className)}
      title={`${what ? `${what} in` : "Opens"} Stripe's ${test ? "test-mode " : ""}dashboard (new tab)`}
    >
      {label}
      {test && showMode ? " (test)" : ""}
      <ExternalLink className="size-3" aria-hidden />
    </a>
  );
}
